module.exports = __webpack_public_path__ + "static/media/AM.c5d9ca6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AM.svg
// module id = 189
// module chunks = 0